import React, { KeyboardEvent } from 'react';
import { Button, DefaultTheme, Keys } from '@guildeducationinc/recess';
import OpenInNewIcon from '@guildeducationinc/recess/icons/OpenInNewIcon';
import { IconProps } from '@guildeducationinc/recess/icons/utilities/IconProps';
import classNames from 'classnames';
import './ContactCardButton.scss';

export interface ContactCardButtonProps {
  disabled?: boolean;
  Icon: React.FC<IconProps>;

  onClick?(e: React.MouseEvent<HTMLElement> | React.FormEvent<HTMLElement>): void;

  onKeyDown: React.KeyboardEventHandler;
  openInNewIcon?: boolean;
  testid: string;
  text: string;
}

/**
 * @name ContactCardButton
 * @description A button component for a Guild support card.
 */
const ContactCardButton: React.FC<ContactCardButtonProps> = ({
  disabled = false,
  Icon,
  onClick,
  onKeyDown,
  openInNewIcon = false,
  testid,
  text,
}) => {
  const onKeyDownHandler = (event: KeyboardEvent, handler: React.KeyboardEventHandler): void => {
    if (event.key === Keys.Enter || event.key === Keys.Space) {
      event.preventDefault();
      handler(event);
    }
  };

  return (
    <Button
      appearance='ghost'
      className={classNames('contactCardButton', disabled && 'contactCardButtonDisabled')}
      disabled={disabled}
      icon={<Icon size={24} color={DefaultTheme.iconColor} />}
      iconDirection='left'
      label={text}
      newWindowNotification={true}
      onClick={onClick}
      onKeyDown={(event) => onKeyDownHandler(event, onKeyDown)}
      tabIndex={disabled ? -1 : 0}
      testid={testid}
      type='button'
    >
      {text}
      {openInNewIcon && (
        <OpenInNewIcon
          className='margin--left_4'
          color={DefaultTheme.iconColor}
          size={18}
          data-testid='contact-card-button-open-in-new-icon'
        />
      )}
    </Button>
  );
};

export default ContactCardButton;
